<template>
  <div>
    <h4 class="text-right mb-4 font-weight-light">
      Trang <span class="primary--text">{{currentPage}}</span> 
      (Tổng <span class="primary--text">{{totalPages}}</span> trang 
      của <span class="primary--text">{{totalItems}}</span> cơ sở)
    </h4>
    <h4 class="text-center mb-4 font-weight-light" v-if="!$store.state.loader && items.length==0">
      Không tìm thấy! Thử điều chỉnh lại các bộ lọc
    </h4>
    <v-row>
      <v-col
        v-for="item in items" 
        :key="item.id"
        cols="12"
        sm="6"
        md="3"
      >
        <v-sheet class="rounded-lg overflow-hidden h-100">
          <v-hover v-slot="{ hover }">
            <v-card flat>
              <router-link
                :to="{ name: 'BusinessView', params: { id: item.id }}"
              >
                <v-img
                  v-if="item.logo"
                  :src="`${config.agriDataBackUrl}/file-download/logo-co-so-cap-giong/${item.logo}`"
                  gradient="to top right, #00796b57, rgb(255 255 255 / 5%)"
                  :class="hover ? 'zoomIn' : 'zoomOut'"
                  :aspect-ratio="16/9"
                />
                <v-img
                  v-else
                  src="@/assets/business-logo-default.png"
                  gradient="to top right, #00796b57, rgb(255 255 255 / 5%)"
                  :class="hover ? 'zoomIn' : 'zoomOut'"
                  :aspect-ratio="16/9"
                />
              </router-link>
              <v-card-title class="pb-1">
                <router-link
                  :to="{ name: 'BusinessView', params: { id: item.id }}"
                  class="black--text text-body-2 font-weight-bold"
                >
                  {{item.tenCoSo}}
                </router-link>
              </v-card-title>
              <v-card-text>
                <div class="text-body-2 mb-2">
                  <v-list-item 
                    class="grow min-h-30"
                    dense
                  >
                    <v-row align="center">
                      <v-icon 
                        small 
                        :color="item.trangThai == 0 ? 'gray' : (item.trangThai == 2 ? 'yellow' : 'primary')"
                        class="mr-1"
                      >
                        mdi-circle
                      </v-icon>
                      <span v-if="item.trangThai == 0">Dừng hoạt động</span>
                      <span v-else-if="item.trangThai == 2">Tạm ngưng hoạt động</span>
                      <span v-else>Đang hoạt động</span>
                      <span class="text-body-2 font-italic ml-4">
                        <v-icon small>mdi-eye</v-icon>
                        {{ item.countview || 1 }}
                      </span>
                    </v-row>
                  </v-list-item>
                </div>
                <div class="text-body-2">
                  <v-icon small>
                    mdi-map-marker
                  </v-icon>Địa chỉ: 
                  {{item.duong}} - {{item.dmXa.ten}} - {{item.dmHuyen.ten}} - {{item.dmTinh.ten}}
                </div>
              </v-card-text>
            </v-card>
          </v-hover>
        </v-sheet>
      </v-col>
      <v-col cols="12">
        <div class="text-center">
          <v-pagination
            v-if="totalPages > 1"
            v-model="currentPage"
            :length="totalPages"
            :total-visible="totalVisible"
            @input="handlePageChange"
          />
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script>
  import { mapState, mapActions } from 'vuex';
  export default {
    props: {
      filterObj: {
        type: Object
      }
    },
    data () {
      return {
        loading: false,
        totalVisible: 7,
        currentPage: 1,
        totalItems: 0,
        totalPages: 0,
        items: []
      }
    },
    computed: {
      ...mapState([
        'config'
      ])
    },
    watch: {
      filterObj(){
        this.initialize();
      }
    },
    mounted () {
      this.initialize();
    },
    methods: {
      ...mapActions([
        'getLoader'
      ]),
      getRequestParams(page) {
        let params = {};

        if (page) {
          params["page"] = page;
        }

        return params;
      },
      handlePageChange(value) {
        this.currentPage = value;
        this.initialize();
        this.$vuetify.goTo(0);
      },
      initialize () {
        const app = this;

        const params = app.getRequestParams(
          app.currentPage,
        );
        
        let request = {
          params: {...params, ...app.filterObj}
        };

        app.getLoader(true);

        axios.get("api/v1/public/get-agridata-breed-business", request)
          .then(response => {
            app.items = response.data.data;
            app.totalItems = response.data.total;
            const caluTotalPage = response.data.total/response.data.per_page;
            app.totalPages = Math.ceil(caluTotalPage);
            app.getLoader(false);
          })
          .catch(function (error) {
            console.log(error);
            app.getLoader(false);
          });
      }
    }
  }
</script>
<style>
  .v-image .v-image__image {
    transition: all 0.2s;
  }
  .v-image.zoomIn .v-image__image {
    transform: scale(1.2);
  }
  .v-image.zoomIn {
    opacity: 0.3;
  }
  .v-image.zoomOut {
    opacity: 1;
  }
</style>